module.exports = __webpack_public_path__ + "static/img/banner-about-03.f5928e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-about-03.jpg
// module id = uImW
// module chunks = 98